import { useLayoutEffect } from 'react';

/** Drawers de push ativos. A marca de raiz é booleana, então instâncias
 *  empilhadas (ex.: no desktop, filtro aberto + "Detalhes" de uma oferta ao
 *  lado) precisam de ref-count — senão o primeiro a desmontar apaga a marca e
 *  desfaz o push do que ainda está aberto. */
let openCount = 0;

/**
 * Marca `:root[data-push-drawer-open]` enquanto um slide-over de "empurrão"
 * (push) está aberto — ANTES do paint (`useLayoutEffect`), em sincronia com o
 * slide do painel, sem 1 frame em overlay antes do push começar. O host reage
 * empurrando a conversa via CSS (web-chat empurra `.chat-main` ≥900px) ou ignora
 * a marca e segue em overlay (console do operador). Fonte única do contrato de
 * push dos slide-overs de voo à direita: o detalhe do voo
 * (`FlightDetailDrawerShell`) e o filtro legado (`FlightFilterDrawer`). O
 * explorer do chat NÃO marca mais nada: ele virou takeover de tela cheia
 * (`FlightExplorerDialog`) — quando o detalhe abre por cima dele, é o próprio
 * takeover que se espreme pela marca daqui (`.fex-takeover` em explorer.css). A
 * marca é ref-counted: só sai quando o ÚLTIMO drawer de push desmonta.
 */
export function usePushDrawerMarker(): void {
  useLayoutEffect(() => {
    if (++openCount === 1) {
      document.documentElement.dataset.pushDrawerOpen = '';
    }
    return () => {
      if (--openCount === 0) {
        delete document.documentElement.dataset.pushDrawerOpen;
      }
    };
  }, []);
}
